import type { WidgetActions } from "../use-widget-actions";
import s from "../cogent.module.css";

/** What the cogent is doing right now, just above where the viewer writes. */
export function WidgetStatusLine({
  actions,
}: {
  readonly actions: WidgetActions;
}) {
  if (actions.wake && actions.offline)
    return (
      <p className={s.statusLine}>
        Offline ·{" "}
        <button
          type="button"
          className={s.link}
          disabled={actions.busy}
          onClick={actions.wake}
        >
          Start
        </button>
      </p>
    );

  return actions.statusLine ? (
    <output className={s.statusLine} data-testid="cogent-doing">
      <span className={s.thinking}>{actions.statusLine}</span>
    </output>
  ) : null;
}
